var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconRestart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 27.856 28.851"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  stroke: "currentColor",
  d: "M2.642 14.426a11.784 11.784 0 0 1 21.71-6.351H18.71a1.071 1.071 0 1 0 0 2.142h7.574a1.07 1.07 0 0 0 1.071-1.071V1.571a1.071 1.071 0 1 0-2.142 0v4.048a13.916 13.916 0 1 0 1.874 14.609 1.071 1.071 0 0 0-1.947-.894 11.785 11.785 0 0 1-22.5-4.909Z"
})));
export default SvgIconRestart;